import PropTypes from 'prop-types';
import React from 'react';

export const PositionPriceTrailWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'POSITION_PRICE_TRAIL',
    category: 'Exit',
    type: 'Position Price Trail',
    domain: 'Underlying',
  };
  const amount = softOrder.amount;
  const priceToBreak = softOrder.priceToBreak;

  return <Component details={details} amount={amount} priceToBreak={priceToBreak} {...rest}/>;
};

PositionPriceTrailWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    amount: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};


